<div class="d-flex step-type-container">
  <div class="step-type">
    <div>{{stepTypeName}}</div>
  </div>
</div>
